const API_BASE = (process.env.REACT_APP_SERVER_URL || '').replace(/\/$/, '');

const normalizePath = (path = '') => (path.startsWith('/') ? path : `/${path}`);

export const buildApiUrl = (path = '') => `${API_BASE}${normalizePath(path)}`;

const getServerOrigin = () => {
    try {
        if (API_BASE) {
            return new URL(API_BASE).origin;
        }
    } catch (error) {
        // ignore
    }
    try {
        return window?.location?.origin || '';
    } catch (error) {
        return '';
    }
};

export const resolveMediaUrl = (url = '') => {
    if (!url) return '';
    const trimmed = url.trim();

    if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
        return trimmed;
    }

    const origin = getServerOrigin();
    const normalizedPath = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    return origin ? `${origin}${normalizedPath}` : normalizedPath;
};

export const parseApiResponse = async (response) => {
    const contentType = response.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const data = isJson ? await response.json() : await response.text();

    if (!response.ok) {
        throw data;
    }

    return data;
};

export const fetchJson = async (path, options = {}) => {
    const response = await fetch(buildApiUrl(path), options);
    return parseApiResponse(response);
};

export const getApiBase = () => API_BASE;
export const getApiOrigin = () => getServerOrigin();

export default fetchJson;
